var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"max-width":"200","max-height":"150","src":_vm.src},on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }